import { light, dark } from './theme';
import uuid from "../../utils/uuid";
import config from "../../../config";
var jsapi = window.document.createElement("script");
var callback_list = [];
var theme_loaded = false;
export default (callback) => {
  if (window.echarts) {
    //通过别的途径加载echarts时，注册主题
    if(!theme_loaded){
      theme_loaded = true;
      window.echarts.registerTheme("ITOCS-theme-light", light);
      window.echarts.registerTheme("ITOCS-theme-dark", dark);
    }
    callback && callback();
    return;
  }
  if (!jsapi.id) {
    jsapi.id = uuid();
    var url = config.ECHART_URL;
    jsapi.src = url;
    callback_list.push(callback);
    jsapi.onload = () => {
      setTimeout(() => {
        theme_loaded = true;
        window.echarts.registerTheme("ITOCS-theme-light", light);
        window.echarts.registerTheme("ITOCS-theme-dark", dark);
        for (let cb of callback_list) {
          cb && cb();
        }
        callback_list = [];
      }, 0);
    };
    document.head.appendChild(jsapi);
  } else {
    callback_list.push(callback);
  }
};
